<template>
  <footer class="footer">
    <div class="footer__logo-box">
      <picture class="footer__logo">
        <img
          srcset="@/assets/imgs/logos/logox1.png 1x, @/assets/imgs/logos/logox2.png 2x, @/assets/imgs/logos/logox3.png 3x"
          alt="Website Logo"
        >
      </picture>
    </div>
    <div class="row">
      <div class="col-1-of-2">
        <div class="footer__navigation">
          <ul class="footer__list">
            <li class="footer__item">
              <a
                href=""
                class="footer__link"
              >Contact</a>
            </li>
            <li class="footer__item">
              <a
                :href="this.$store.getters.github_link"
                class="footer__link"
                target="_blank" 
                rel="noopener noreferrer"
              >Github</a>
            </li>
            <li class="footer__item">
              <a
                :href="this.$store.getters.linkedin_link"
                class="footer__link"
                target="_blank" 
                rel="noopener noreferrer"
              >Linkedin</a>
            </li>
            <li class="footer__item">
              <a
                :href="this.$store.getters.twitter_link"
                class="footer__link"
                target="_blank" 
                rel="noopener noreferrer"
              >Twitter</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-1-of-2">
        <p class="footer__copyright">
          Built by <a
            href="#"
            class="footer__link"
          >Aaron Fletcher</a> Copyright &copy; by Aaron Fletcher.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
